import { render, staticRenderFns } from "./IconArchive.vue?vue&type=template&id=1b969e6e&"
var script = {}
import style0 from "./IconArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b969e6e')) {
      api.createRecord('1b969e6e', component.options)
    } else {
      api.reload('1b969e6e', component.options)
    }
    module.hot.accept("./IconArchive.vue?vue&type=template&id=1b969e6e&", function () {
      api.rerender('1b969e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconArchive.vue"
export default component.exports